/**
 * step 1001: preparing react application
 */
import React from "react";                                  //import React
import ReactDOM from "react-dom/client";                    //
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";            // web vitals for seo or optimization (google, bing, browser ...)
import './i18n';                                            // multi language package (refer to public/locales/tranlate/...)

const root = ReactDOM.createRoot(document.getElementById("root"));

// TODO: must remove if not used
root.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>
);
// note to use webVital
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
